import { stringify } from "qs";
import request from "../request";
import { url } from "../service-utils";

/**
 * 服务列表
 * cc
 * @param page
 * @param pageSize
 */
export async function getServiceList(payload) {
  const params = { ...payload };
  return request(
    `${url.meetingSign}/meeting/service/list?${stringify(params)}`
  );
}

/**
 * 删除会议
 * cc
 * @param serviceId
 */
export async function deleteService(payload) {
  const params = { ...payload };
  return request(
    `${url.meetingSign}/meeting/service/delete?${stringify(params)}`
  );
}

/**
 * 修改/创建服务
 * cc
 * @param id(修改才传)
 * @param serviceName
 * @param required
 * @param optionalAmount
 * @param note
 */
export async function createService(payload) {
  const params = { ...payload };
  return request(`${url.meetingSign}/meeting/service/save`, {
    method: "POST",
    data: params
  });
}
